<template>
  <div>
    <a-drawer :width="1200" :closable="false" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="close">
      <a-skeleton v-if="loading" active />
      <div v-else>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-descriptions size="small">
              <span slot="title">
                <span>{{ caseData.name }}</span>
                <span class="description_subtitle">#{{ caseData.key }}</span>
              </span>
            </a-descriptions>
          </a-col>
        </a-row>
        <a-divider orientation="left"><span style="font-size: 14px; font-weight: normal">用例详情</span></a-divider>
        <div class="case-detail">
          <a-form-model ref="form" :rules="rules" :model="form" layout="vertical" style="width: 98%">
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-model-item label="用例名称" prop="name">
                  <a-input v-model="form.name" placeholder="用例名称" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-model-item label="优先级" prop="priority">
                  <a-select v-model="form.priority" allow-clear>
                    <a-select-option v-for="(item, key) in casePrioritys" :key="key" :value="item.value">
                      <a-tag :color="item.color"> {{ item.label }}</a-tag>
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="所属模块" prop="module_id">
                  <a-tree-select v-if="moduleData" v-model="form.module_id" show-search :filter-tree-node="filterModule" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择所属目录" :tree-data="moduleData" tree-default-expand-all @change="onChange('module_id')" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-model-item label="前置条件">
                  <a-textarea v-model="form.precondition" placeholder="前置条件" :auto-size="{ minRows: 3 }" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="用例步骤" prop="steps">
                  <a-table
                    class="steps_table"
                    :show-header="false"
                    :pagination="false"
                    :columns="columns"
                    :data-source="form.steps"
                    :row-key="
                      (record, index) => {
                        return index;
                      }
                    "
                  >
                    <span slot="step" slot-scope="text, record">
                      <a-textarea v-model="record.step" auto-size placeholder="操作步骤" />
                    </span>
                    <span slot="result" slot-scope="text, record">
                      <a-textarea v-model="record.result" auto-size placeholder="预期结果" />
                    </span>
                    <span slot="images" slot-scope="text, record">
                      <CaseStepImages :data-list.sync="record.images" />
                    </span>
                    <span slot="action" slot-scope="text, record, index">
                      <span class="icon-wrap" style="cursor: pointer" @click.stop="deleteStep(index)">
                        <a-icon type="delete" />
                      </span>
                    </span>
                  </a-table>
                  <a class="add-step" type="link" @click="onAddStep">
                    <a-icon type="plus" />
                    添加步骤
                  </a>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="24">
                <a-form-model-item label="用例标签" prop="tags">
                  <a-select v-model="form.tags" mode="multiple" :max-tag-count="5" placeholder="请选择用例标签">
                    <a-select-option v-for="(item, index) in tagData" :key="index" :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item label="备注" prop="description">
                  <vditor-editor v-model="form.description" :height="200" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
          <a-button type="primary" :size="size" :loading="loading" icon="save" @click="onSubmit()"> 保存</a-button>
        </div>
      </div>
      <div style="padding-top: 2px">
        <a-divider orientation="left"><span style="font-size: 14px; font-weight: normal">用例评审</span></a-divider>
        <a-descriptions :column="3" size="small">
          <a-descriptions-item label="评审结果(上次)">
            <review-case-result-edit :disabled="true" :review-id="reviewId" :case-id="caseData.id" :result="caseData.result" />
          </a-descriptions-item>
          <a-descriptions-item label="评审时间(上次)">
            <span v-if="caseData.result !== 1">{{ caseData.reviewTime }}</span>
            <span v-else>--</span>
          </a-descriptions-item>
          <a-descriptions-item label="评审人员(上次)">
            <span v-if="caseData.result !== 1">{{ caseData.reviewer ? caseData.reviewer.nickname : '--' }}</span>
            <span v-else>--</span>
          </a-descriptions-item>
        </a-descriptions>
        <a-textarea v-model="resultComment" placeholder="评审结果备注" :auto-size="{ minRows: 3, maxRows: 3 }" />
      </div>
      <div style="position: absolute; right: 25px; bottom: 25px">
        <a-button type="dashed" :size="size" :disabled="!hasBefore" style="margin-right: 10px" @click="onBeforeCase">
          <a-icon type="left" />
          上一条
        </a-button>
        <a-button type="dashed" :size="size" :disabled="!hasNext" style="margin-right: 10px" @click="onNextCase">
          下一条
          <a-icon type="right" />
        </a-button>
        <a-tooltip>
          <template slot="title"> 评审结果置为"已评审"并加载下一条 </template>
          <a-button class="pass-btn" :size="size" @click="onCaseReviewed"> 已评审 </a-button>
        </a-tooltip>
        <a-tooltip>
          <template slot="title"> 评审结果置为"待更新"并加载下一条 </template>
          <a-button class="fail-btn" :size="size" @click="onCaseNeedUpdate"> 待更新 </a-button>
        </a-tooltip>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { tagList } from '@/api/system/tag';
import { caseUpdate, moduleList } from '@/api/project/case';
import { casePrioritys, caseStatus } from '@/utils/dictionary';
import { reviewCaseDetail, updateReviewItemResult } from '@/api/project/review';

import VditorEditor from '@/components/VditorEditor';
import CaseStepImages from '@/pages/project/case/components/CaseStepImages.vue';
import ReviewCaseResultEdit from '@/pages/project/review/components/ReviewCaseResultEdit';

const columns = [
  // {
  //   dataIndex: 'number',
  //   key: 'number',
  //   align: 'center',
  //   width: 30,
  //   customRender: (_text, _row, index) => {
  //     return index + 1;
  //   }
  // },
  {
    dataIndex: 'step',
    key: 'step',
    width: 300,
    scopedSlots: { customRender: 'step' }
  },
  {
    dataIndex: 'result',
    key: 'result',
    width: 300,
    scopedSlots: { customRender: 'result' }
  },
  {
    dataIndex: 'images',
    key: 'images',
    width: 350,
    scopedSlots: { customRender: 'images' }
  },
  {
    key: 'action',
    width: 50,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  components: { ReviewCaseResultEdit, VditorEditor, CaseStepImages },
  props: {
    display: {
      type: Boolean,
      default: false
    },
    reviewId: {
      type: [Number, String],
      default: null
    },
    caseId: {
      type: [Number, String],
      default: null
    },
    hasNext: {
      type: Boolean,
      default: false
    },
    hasBefore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns,
      caseStatus,
      casePrioritys,
      loading: true,
      visible: false,
      caseData: {},
      projectId: parseInt(this.$route.params.project_id) || null,
      size: 'small',
      resultComment: '',
      autoLoadNextCase: false,
      moduleData: [],
      form: {
        steps: []
      },
      rules: {
        name: [{ required: true, message: '用例名称不能为空', trigger: 'blur' }],
        priority: [{ required: true, message: '优先级不能为空', trigger: 'blur' }],
        module_id: [{ required: true, message: '所属目录不能为空', trigger: 'blur' }],
        precondition: [{ required: true, message: '前置条件不能为空', trigger: 'blur' }]
      },
      modalVisible: false,
      issueId: null
    };
  },
  watch: {
    display() {
      this.visible = this.display;
      if (this.visible === true) {
        this.getTagList();
        this.getModuleList();
        if (this.caseId !== null) {
          this.getCaseDetail();
        }
      }
    },
    caseId() {
      if (this.caseId !== null) {
        this.getCaseDetail();
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.caseId) {
            caseUpdate({ ...this.form, project_id: this.projectId, id: this.caseId })
              .then(() => {
                this.$message.success('用例修改成功');
                this.getCaseDetail();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    filterModule(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },
    getTagList() {
      tagList({ group_code: 'case' }).then(res => {
        this.tagData = res.data.items;
      });
    },
    // 获取模块列表
    getModuleList() {
      moduleList({ project_id: this.projectId, return_type: 'tree' }).then(res => {
        this.moduleData = res.data.items;
      });
    },
    deleteStep(index) {
      this.form.steps.splice(index, 1);
    },

    onAddStep() {
      this.form.steps.push({ step: null, result: null });
    },

    // 数据变更的回调
    onChange(target) {
      this.$refs.form.validateField([target]);
    },
    autoLoadNextCaseChange(e) {
      this.autoLoadNextCase = e.target.checked;
    },
    // 获取用例详情
    getCaseDetail() {
      reviewCaseDetail({ project_id: this.projectId, review_id: this.reviewId, case_id: this.caseId })
        .then(res => {
          this.caseData = res.data;
          this.resultComment = res.data.resultComment;
          this.form = {
            name: this.caseData.name,
            priority: this.caseData.priority,
            module_id: this.caseData.module_id,
            precondition: this.caseData.precondition,
            description: this.caseData.description ? this.caseData.description : '',
            steps: this.caseData.steps.length > 0 ? this.caseData.steps : [{ step: null, result: null }],
            tags: this.caseData.tags.map(item => {
              return item.id;
            })
          };
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    close() {
      this.$emit('close');
    },
    onAddIssue() {
      this.modalVisible = true;
      this.issueId = null;
    },
    closeIssueModal() {
      this.$message.success('创建缺陷成功!');
      this.modalVisible = false;
    },
    onCaseReviewed() {
      this.updateReviewCaseResult(3, this.resultComment);
    },
    onCaseNeedUpdate() {
      this.updateReviewCaseResult(4, this.resultComment);
    },
    onNextCase() {
      this.$emit('next');
    },
    onBeforeCase() {
      this.$emit('before');
    },
    updateReviewCaseResult(result, description) {
      updateReviewItemResult({
        review_id: this.reviewId,
        result: result,
        item_id: this.caseId,
        description: description
      }).then(() => {
        this.$message.success('结果更新成功');
        this.$emit('next');
        // this.$emit('change');
        // if (this.autoLoadNextCase) {
        //   this.$emit('next')
        // } else {
        //   this.getCaseDetail()
        // }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.case-detail {
  overflow-y: auto;
  height: calc(~'100vh - 350px');
}

/deep/ .ant-descriptions-title {
  margin-bottom: 0px;
}

.description_subtitle {
  margin-left: 8px;
  font-weight: normal;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
}

/deep/ .drawer-bottom-menu {
  position: absolute;
  width: 100%;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

/deep/ .ant-form-item {
  margin-bottom: 8px;
}

/deep/ .steps_table .ant-input {
  resize: none;
  border: none;
  border-radius: 0;
  background-color: transparent;
  margin: 2px 0;
  // border-bottom: 1px solid #d9d9d9;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:focus {
  border: none;
  border-bottom: 1px solid #1890ff;
  box-shadow: none;
}

/* 取消 多行文本框 获取焦点的 边框 效果 */
/deep/ .steps_table .ant-input:hover {
  border-bottom: 1px solid #1890ff;
}

/deep/ .ant-table-tbody > tr > td {
  padding: 0;
}

.steps_table {
  margin-bottom: 4px;
}

.pass-btn {
  color: #fff;
  background-color: #87d068;
  border-color: #87d068;
  margin-right: 10px;
}

.fail-btn {
  color: #fff;
  background-color: #e95409;
  border-color: #e95409;
  margin-right: 10px;
}

.block-btn {
  color: #fff;
  background-color: #bab8b7;
  border-color: #bab8b7;
  margin-right: 10px;
}

.na-btn {
  color: #fff;
  background-color: #b24610;
  border-color: #b24610;
  margin-right: 10px;
}
</style>
